<template>
	<div class="flex flex_column flex_items_center secondary_color">
		<div class="flex flex_center coverage_circle_container" :class="{'pointer': needsUpdate}"
			 style="width: 80px; height: 80px"
			 @click="updateCoverage"
		>
			<span v-if="!needsUpdate" class="font_lg"> {{ coveragePercentageDisplay }}</span>
			<i v-if="needsUpdate" class="font_lg fa fa-refresh"/>
			<md-progress-spinner class="md-default" :md-value="100" :md-diameter="80"/>
			<md-progress-spinner class="md-primary" :md-value="ratio * 100" :md-diameter="80"/>
		</div>
		<span class="font_sm">
			{{ description }}
		</span>
		<el-tooltip v-if="tooltip"
					:open-delay="300" placement="bottom"
					:content="tooltip">
			<i class="fa fa-info-circle secondary_color" aria-hidden="true"/>
		</el-tooltip>
	</div>
</template>

<script>
import {formatAsPercentage} from "@/common/format";

export default {
	props: {
		needsUpdate: { type: Boolean, default: true },
		ratio: { type: Number, default: null },
		description: { type: String, default: null },
		tooltip: { type: String, default: null }
	},
	computed: {
		coveragePercentageDisplay() {
			return formatAsPercentage(this.ratio, { decimals : 0, showEmptyAsNotAvailable: true, default: "0%" });
		}
	},
	methods: {
		updateCoverage() {
			this.$emit("update");
		}
	},
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/base_variables.scss";

.coverage_circle_container {
	position: relative;

	span,
	i,
	.md-progress-spinner {
		position: absolute;
	}
}
</style>